import React, { Fragment, useEffect, useState } from "react";
import DefaultButton from "../../../components/buttons/defaultButton";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { RiCloseLine } from "react-icons/ri";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { MenuDrawer } from "../menuDrawer/menuDrawer";
import useDashboardMenu from "../../../../hooks/useDashboardMenu";
import useUserRole from "../../../../hooks/useUserRole";
import { _setIsPlanSheet } from "../../../../store/slices/global.slice";
import DynamicNotification from "./components/DynamicNotification";
import HandleAttendance from "./components/handleAttendance";
import logo from "@/views/assets/logos/icon.png";

const Header = ({ onToggleSidebar, isCompressed }) => {
  const [isGlobalSearchOpen, setIsGlobalSearchOpen] = useState(false);
  const [isSessionOpen, setIsSessionOpen] = useState(false);
  const role = useUserRole();
  // Since we removed workspace slice, provide a fallback
  const default_workspace = {
    name: "HR",
    sessions: [],
  };
  const { settingMenu, dashboardMenu } = useDashboardMenu();
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const user = userInfo?.user || {
    name: "User",
    profile_image: null,
    admin: 0,
  };
  const user2 = useSelector((state) => state?.user?.user);
  const userType = user2?.type;
  const isAdmin = Number(userType) === 0 || Number(userType) === 1;
  const navigate = useNavigate();
  const location = useLocation();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const toggleDrawer = () => setDrawerOpen((prev) => !prev);
  const userRoleData = useUserRole();
  const dispatch = useDispatch();

  const handleSearch = () => {
    setIsGlobalSearchOpen(true);
  };

  const handleSession = () => {
    setIsSessionOpen(true);
  };

  const closeModal = () => {
    setIsGlobalSearchOpen(false);
  };

  const handleOpenSheet = () => {
    dispatch(_setIsPlanSheet(true));
  };

  return (
    <Fragment>
      {/* Desktop Header — only render when there is content (non-admin has attendance button) */}
      {!isAdmin && (
        <div className="hidden md:flex w-full h-14 border-b border-gray-100 bg-white justify-between items-center px-4 gap-3 flex-shrink-0">
          <div className="flex items-center" />
          <div className="flex items-center gap-3">
            <HandleAttendance />
          </div>
        </div>
      )}

      {/* {/ Mobile Menu /} */}

      <div className="md:hidden flex flex-row items-center justify-between h-20 w-full p-4">
        <div className="flex items-center">
          <img
            src={logo}
            alt="logo"
            className="h-10 w-auto object-contain"
          />
        </div>

        <div className="flex">
          <div className="!z-50">
            <DefaultButton
              onClick={toggleDrawer}
              variant="iconButton"
              icon={isDrawerOpen ? <RiCloseLine /> : <HiOutlineMenuAlt3 />}
            />
          </div>
          <MenuDrawer
            isOpen={isDrawerOpen}
            handleClose={toggleDrawer}
            menu={dashboardMenu}
            settingmenu={settingMenu}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default Header;
